module.exports = __webpack_public_path__ + "img/cloud-5.9af6faf0.png";